import React, { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import Header from "../Header";
import Footer from "../Footer";
import PanelLeft from "../PanelLeft";
import { ProgressBarProvider } from "react-redux-progress";
import axios from "axios";
import Config from "constants/configs";
import { Cookies } from "react-cookie";
import { mdiMenu } from "@mdi/js";
import Icon from "@mdi/react";
import Sidebar from "common/SideBarMenu/Sidebar";
import HeaderNew from "common/HeadeNew";
import { version } from "../../../package.json";
import LoadingPage from "common/Loading";

const LayoutNew = (props) => {
  const [isScrolled, setScroll] = useState(window.scrollY > 30);
  useEffect(() => {
    document.addEventListener("scroll", handleScroll);
    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScroll = () => {
    const Y = window.scrollY;
    setScroll(Y > 30);
  };
  const [sidebar, setSidebar] = useState(true);

  const showSidebar = () => {
    setSidebar(!sidebar);
    if (sidebar === true) {
      props.isShowMenuShow();
    } else {
      props.isShowMenuHide();
    }
  };

  return (
    <Fragment>
      {/* <Header
        className="top-left"
        showBackground={isScrolled}
        isNotBranchTong={props.isNotBranchTong}
        isBranch={props.isBranch}
        isDisable={props.isDisable}
      /> */}
      {/* <PanelLeft className="box_left" /> */}
      <div className="wrappNew">
        <Sidebar sidebar={sidebar} />

        <div className="main-body bg-new">
          <div className={`header_new ${sidebar ? "" : "toggledLeft"}`}>
            <div className="iconSidebar">
              <Icon
                path={mdiMenu}
                title=""
                size={1.5}
                style={{ color: "#707070" }}
                onClick={showSidebar}
              />
            </div>
            <HeaderNew
              showBackground={isScrolled}
              isNotBranchTong={props.isNotBranchTong}
              isBranch={props.isBranch}
              isDisable={props.isDisable}
              isCheckBranch={props.isCheckBranch}
            />
          </div>
          {props.isProgress ? <LoadingPage /> : null}
          {props.isProgress1 ? <LoadingPage /> : null}
          {/* <ProgressBarProvider isActive={props.isProgress} /> */}
          <Fragment>
            {props.isPrint === true ? (
              <div className="contentNew">{props.children}</div>
            ) : (
              <div className="contentNew-main">
                <div className="content-danhSach">{props.children}</div>
              </div>
            )}
          </Fragment>
        </div>
      </div>
    </Fragment>
  );
};

LayoutNew.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.array,
    PropTypes.object,
  ]),
};

export default LayoutNew;
